import { Platform } from './AuthConstants';
import { AppName } from '../utils/Constants';

export enum SavePasswordMode {
	Never = 'Never',
	SecureOnly = 'SecureOnly',
	Always = 'Always',
}

export enum ConnectionSecurityMode {
	SecureOnly = 'SecureOnly',
	Any = 'Any',
}

export enum Protocol {
	IntegratedWindows = 'integratedwindows',
	ExplicitForms = 'explicitforms',
	CitrixAGBasic = 'citrixagbasic',
	CitrixAGBasicNoPassword = 'citrixagbasicnopassword',
	FormsVariant = 'formsvariant',
	Certificate = 'certificate',
	HttpBasic = 'httpbasic',
}

interface AuthConfig {
	primaryTokenLifetime?: string;
	secondaryTokenLifetime?: string;
	primaryTokenLifetimeOnPrem?: string;
	secondaryTokenLifetimeOnPrem?: string;
	nativeLoggingEnabled: boolean;
	longLivedTokenSupport: boolean;
	CredentialInsertionEnabled: boolean;
	platform?: Platform;
	saveTokens: boolean;
	compressedGroupsEnabled?: boolean;
	locale?: string;
	isUnifiedAuthenticationEnabled?: boolean;
	isDSAuthResiliencyEnabled?: boolean;
	isSimplifyBeaconLogicEnabled?: boolean;
	rememberUsername?: boolean;
	savePasswordMode?: SavePasswordMode;
	uiInactivityTimeOutForOnPremInSeconds?: number;
	protocolOrder?: Protocol[];
	hostApp?: AppName;
	connectionSecurityMode?: ConnectionSecurityMode;
	httpBasicAuthEnabled?: boolean;
}

//Auth Configuration file
export const config: AuthConfig = {
	primaryTokenLifetime: '1.15:00:00', //1 day 15 hours
	secondaryTokenLifetime: '1.00:00:00', //1 day
	primaryTokenLifetimeOnPrem: '0.20:00:00', //20 hours
	secondaryTokenLifetimeOnPrem: '0.01:00:00', //1 hour
	nativeLoggingEnabled: true,
	longLivedTokenSupport: false,
	CredentialInsertionEnabled: false,
	saveTokens: true,
	compressedGroupsEnabled: false,
	locale: 'en-US',
	isUnifiedAuthenticationEnabled: false,
	isDSAuthResiliencyEnabled: false,
	isSimplifyBeaconLogicEnabled: false,
	rememberUsername: true,
	savePasswordMode: SavePasswordMode.Always,
	uiInactivityTimeOutForOnPremInSeconds: 120,
	protocolOrder: [
		Protocol.HttpBasic,
		Protocol.IntegratedWindows,
		Protocol.CitrixAGBasic,
		Protocol.CitrixAGBasicNoPassword,
		Protocol.Certificate,
		Protocol.FormsVariant,
		Protocol.ExplicitForms,
	],
	connectionSecurityMode: ConnectionSecurityMode.SecureOnly,
};
